/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

/**
 * Formats a parsed API value as readable text without the outer braces or
 * quotes around object keys and string values.
 *
 * @param value - The parsed API value, or `null` when no value is present.
 * @returns The formatted value, or an empty string when `value` is nullish.
 *
 * @example
 * formatJSON({ rootHints: ["KING_ROOT_APP"], rootConfidence: 0.95 })
 * // "rootHints: [\n    KING_ROOT_APP\n  ],\n  rootConfidence: 0.95"
 */
export function formatJSON(value: unknown): string {
    if (value == null) return ""

    // Preserve JSON's indentation and line breaks; views can choose whether to
    // preserve that whitespace when rendering the result.
    return JSON.stringify(value, undefined, 2).replace(/[{}"]/g, "").trim()
}
